<div class="action-bar">
  <div class="action-buttons">
    @if (canEdit) {
      <p-button
        icon="pi pi-comment"
        label="Comentário"
        [outlined]="activeAction() !== 'comment'"
        [severity]="activeAction() === 'comment' ? 'primary' : 'secondary'"
        size="small"
        (onClick)="setAction('comment')" />
      <p-button
        icon="pi pi-paperclip"
        label="Anexo"
        [outlined]="activeAction() !== 'attachment'"
        [severity]="activeAction() === 'attachment' ? 'primary' : 'secondary'"
        size="small"
        (onClick)="setAction('attachment')" />
      <p-button
        icon="pi pi-clock"
        [label]="getApontamentoButtonLabel()"
        [severity]="getApontamentoButtonSeverity()"
        variant="outlined"
        size="small"
        (onClick)="openTimeEntryModal()" />
      <div
        class="edit-mode-switch"
        pTooltip="Edite vários campos e salve tudo de uma vez."
        tooltipPosition="top">
        <p-toggleSwitch
          inputId="bulkEditModeSwitch"
          [ngModel]="bulkEditActive()"
          (ngModelChange)="onSwitchToggled($event)" />
        <label class="edit-mode-switch__label" for="bulkEditModeSwitch">Modo Edição</label>
      </div>
    }
    <ng-content></ng-content>
  </div>

  @if (canEdit) {
    <div class="action-input" [class.drag-over]="isDragging()">
      @if (uploadingAttachment()) {
        <div class="loading-overlay">
          <i class="pi pi-spin pi-spinner text-3xl mb-2"></i>
          <span class="font-medium">Processando anexo...</span>
        </div>
      }
      @switch (activeAction()) {
        @case ('comment') {
          <div class="comment-input">
            <div class="comment-textarea-container">
              <textarea
                pTextarea
                [autoResize]="true"
                [rows]="4"
                placeholder="Digite seu comentário..."
                [ngModel]="commentText()"
                (ngModelChange)="commentText.set($event)"
                class="w-full"
                (keydown.control.enter)="onSendComment()"></textarea>
            </div>
            <div class="comment-actions">
              <p-toggleButton
                [(ngModel)]="isPublicComment"
                onLabel="Público"
                offLabel="Privado"
                [onIcon]="'pi pi-globe'"
                [offIcon]="'pi pi-lock'"
                styleClass="comment-visibility-toggle" />
              <p-button
                icon="pi pi-send"
                label="Enviar"
                size="small"
                [loading]="sending()"
                [disabled]="!commentText().trim()"
                (onClick)="onSendComment()" />
            </div>
          </div>
        }
        @case ('attachment') {
          <div class="w-full">
            <p-fileUpload
              #fileUpload
              mode="advanced"
              [customUpload]="true"
              (uploadHandler)="onUploadAttachment($event, fileUpload)"
              [multiple]="false"
              [auto]="true"
              styleClass="action-fileupload w-full"
              [disabled]="uploadingAttachment()">
              <ng-template pTemplate="content">
                <div
                  class="attachment-placeholder w-full h-full"
                  *ngIf="!fileUpload.hasFiles()"
                  (click)="
                    fileUpload.basicFileInput
                      ? fileUpload.basicFileInput.nativeElement.click()
                      : fileUpload.advancedFileInput.nativeElement.click()
                  ">
                  <i class="pi pi-cloud-upload text-3xl mb-1"></i>
                  <span class="font-medium">Arraste um anexo ou clique para selecionar</span>
                </div>
              </ng-template>
            </p-fileUpload>
            <div class="paste-text-container mt-3">
              <input
                type="text"
                pInputText
                placeholder="Cole um texto ou imagem para criar um arquivo"
                [ngModel]="pasteText()"
                (ngModelChange)="onPasteTextChange($event)"
                (paste)="onPasteImage($event)"
                class="w-full"
                [disabled]="uploadingAttachment()" />
            </div>
          </div>
        }
        @case ('timeentry') {
          <!-- Conteúdo removido - botão abre modal diretamente -->
          <div class="timeentry-placeholder">
            <span>Clique em "Apontamento" para gerenciar apontamentos</span>
          </div>
        }
      }
    </div>
  }
</div>

<!-- File Name Dialog -->
<p-dialog
  [(visible)]="showFileNameDialog"
  header="Nome do Arquivo"
  [modal]="true"
  [style]="{ width: '520px', maxWidth: 'calc(100vw - 2rem)' }"
  [breakpoints]="{ '768px': '95vw' }"
  appendTo="body">
  <div class="flex flex-column gap-3">
    <div>
      <label for="fileName" class="block mb-2 font-semibold"
        >Nome do arquivo (edite se desejar):</label
      >
      <input
        id="fileName"
        type="text"
        pInputText
        placeholder="Ex: Relatório, Anotações, etc"
        [ngModel]="fileName()"
        (ngModelChange)="fileName.set($event)"
        class="w-full"
        (keydown.enter)="onConfirmFileName()" />
      <small class="text-color-secondary mt-1 block"
        >A extensão do arquivo será preservada automaticamente.</small
      >
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="Cancelar"
      icon="pi pi-times"
      (onClick)="onCancelFileName()"
      severity="secondary" />
    <p-button
      label="Criar"
      icon="pi pi-check"
      (onClick)="onConfirmFileName()"
      [disabled]="!fileName().trim()" />
  </ng-template>
</p-dialog>

<!-- Time Entry Modal -->
<app-time-entry-modal
  [ticket]="ticket"
  [(visible)]="showTimeEntryModal"
  [ticketTimeEntries]="getTimeEntries()"
  [activeTimeEntry]="activeTimeEntry()"
  [initialTaskId]="preSelectedTaskId()"
  (timeEntryAdded)="onTimeEntryModalSaved($event)"
  (timeEntryStopped)="onStopTimeEntry()" />
